enum ParticipantScopes {
  OpenId = 'openid',
  Email = 'email',
  Profile = 'profile',

  ReadProfile = 'read:profile',
  WriteProfile = 'write:profile',

  ReadEvents = 'read:events',
  WriteEvents = 'write:events',

  JoinEvent = 'join:events',

  ReadCalendar = 'read:calendar',
  WriteCalendar = 'write:calendar',

  ReadChats = 'read:chats',
  WriteChats = 'write:chats',
  ExportChats = 'export:chats',

  ReadGamecast = 'read:gamecast',
  WriteGamecast = 'write:gamecast',

  ReadEC2 = 'read:ec2',
  WriteEC2 = 'write:ec2',

  ReadCustomers = 'read:customers',
  WriteCustomers = 'write:customers',

  TrackAnalytics = 'track:analytics',

  ReadPixelStreamingLogs = 'read:pixel-streaming-logs',
  WritePixelStreamingLogs = 'write:pixel-streaming-logs',

  ReadPixelStreamingClients = 'read:pixel-streaming-clients',
  WritePixelStreamingClients = 'write:pixel-streaming-clients',

  ReadCoreweave = 'read:coreweave',
  WriteCoreweave = 'write:coreweave',

  ReadDolby = 'read:dolby',
  WriteDolby = 'write:dolby',
  StreamDolby = 'stream:dolby',

  UploadFiles = 'upload:files',

  ReadMaps = 'read:maps',
  WriteMaps = 'write:maps',

  ReadParticipants = 'read:participants',
  WriteParticipants = 'write:participants',
  UpdateParticipantAvatar = 'update:participant:avatar',
  DeleteParticipants = 'delete:participants',

  ReadRooms = 'read:rooms',
  WriteRooms = 'write:rooms',

  ReadAvatars = 'read:avatars',
  WriteAvatars = 'write:avatars',

  ReadSkins = 'read:skins',
  WriteSkins = 'write:skins',

  ReadOrganizations = 'read:organizations',
  WriteOrganizations = 'write:organizations',

  ReadWorlds = 'read:worlds',
  CreateWorlds = 'create:worlds',
  UpdateWorlds = 'update:worlds',
  DeleteWorlds = 'delete:worlds',

  ReadLevelEditorEntry = 'read:level-editor-entry',
  CreateLevelEditorEntry = 'create:level-editor-entry',
  UpdateLevelEditorEntry = 'update:level-editor-entry',
  DeleteLevelEditorEntry = 'delete:level-editor-entry',

  ReadIXRData = 'read:ixr-data',
  ReadIXRName = 'read:ixr-name',

  SetTCs = 'set:tcs',
  ResetUserState = 'reset:state',

  WriteFeedbackData = 'write:feedback',

  ReadGameLift = 'read:gamelift',
  WriteGameLift = 'write:gamelift',

  ReadUserRoles = 'read:user-roles',
  CreateUserRoles = 'create:user-roles',
  UpdateUserRoles = 'update:user-roles',
  DeleteUserRoles = 'delete:user-roles',

  PublishEvent = 'publish:event',

  ReadEventParticipant = 'read:event-participant',
  CreateEventParticipant = 'create:event-participant',
  UpdateEventParticipant = 'update:event-participant',
  DeleteEventParticipant = 'delete:event-participant',

  ReadAnalytics = 'read:analytics',

  // Admin UI permissions
  ViewUIAdminScheduleEvent = 'view:ui-admin-schedule-event',
  ViewEventAccessControlList = 'view:ui-admin-event-access-control',

  //Hub
  HubAdminTools = 'view:hub-admin-tools',
  HubTrainingToolHubEvent = 'view:hub-training-tools',
  HubEventShareScreen = 'share:screen',
  HubEventShareCamera = 'share:camera',
  HubRiseHand = 'view:hub-rise-hand',
  HubPrivateChat = 'enable:hub-private-chat',
  HubBroadcastEnabled = 'enable:hub-broadcast',
  HubFollowMe = 'enable:hub-follow-me',
}

export default ParticipantScopes;
